export function getFieldAndBindPath(strModelPath, appName){
    let schema = window.APP.schema ;
    if(appName){
        schema = window.APPS[appName].schema ;
    }
    let field = null;
    if(!strModelPath){
        return { field: null, bindPath: null} ;
    }
    const modelPath = strModelPath.split(".") ;
    const modelName = modelPath.shift() ;
    let bindPath = [] ;
    const modelDef = schema.models.find(m => m.name === modelName) ;
    if(!modelDef){
        throw "Model "+modelName+" is unknown" ;
    }
    let columns = modelDef.columns ;
    let fieldName = modelPath.shift();
    let tablePath = [ modelDef.name ] ;
    while(fieldName){
        bindPath.push(fieldName) ;

        const f = columns.find(m => m.name === fieldName) ;
        if(f){
            field = f;
        }

        if(!modelDef){
            throw "Field "+fieldName+" is unknown" ;
        }

        if(field && field.submodel){
            tablePath.push(field.submodel.name) ;
            columns = field.submodel.columns ;
        }
        fieldName = modelPath.shift();
    }
    if(field){
        field.tableName = tablePath.join("_") ;
    }
    return {field, bindPath};
}